<template>
  <v-card>
    <v-card-title class="pl-4" style="height: 64px">
      <span :class="data.name ? '':'grey--text'" class="title pr-4">{{data.name || '未命名'}}</span>
      <div>
        <v-layout class="text-xs-right" wrap>
          <v-flex xs6>
            <span class="grey--text caption mr-2">登记时间</span>
            <span class="pr-4">{{timeStringify(data.creationTime)}}</span>
          </v-flex>
          <v-flex xs6>
            <span class="grey--text caption mr-2">上次更新</span>
            <span class="pr-4">{{timeStringify(data.lastUpdateTime)}}</span>
          </v-flex>
        </v-layout>
      </div>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-card-title>
    <v-card-text>
      <!--<h3>{{data === null}}/{{data}}/</h3>-->
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="用户姓名"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.person"
              v-model="data.name"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="用户账号"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.loginId"
              v-model="data.loginId"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              :disabled="readonly"
              label="电子邮箱"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.email"
              v-model="data.email"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              :disabled="readonly"
              label="电话号码"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.phone"
              v-model="data.phone"
            ></v-text-field>
          </v-flex>
          <!--<v-flex xs4>-->
          <!--<v-text-field-->
          <!--disabled-->
          <!--label="证件类型"-->
          <!--placeholder="N/A"-->
          <!--prepend-icon="$vuetify.icons.idCardType"-->
          <!--&gt;</v-text-field>-->
          <!--</v-flex>-->
          <!--<v-flex xs4>-->
          <!--<v-text-field-->
          <!--disabled-->
          <!--label="证件号码"-->
          <!--placeholder="N/A"-->
          <!--prepend-icon="$vuetify.icons.idCard"-->
          <!--&gt;</v-text-field>-->
          <!--</v-flex>-->
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="登记类型"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.group"
              v-model="data.typeName"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              :value="data.orgGroupName"
              disabled
              label="所在单位"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.org"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn v-if="readonly" color="primary" class="mx-0" flat @click="goEditPhone">修改手机</v-btn>
            <v-btn v-if="readonly" color="primary" class="mx-0" flat @click="goEditEmail">修改邮箱</v-btn>
            <v-btn v-if="readonly" color="primary" class="mx-0" flat @click="unBindWechatConfirm">解除微信绑定</v-btn>
            <!--<v-btn-->
            <!--v-if="isEdit"-->
            <!--:loading="submitLoading"-->
            <!--@click="changeSelfInfo"-->
            <!--flat-->
            <!--color="primary"-->
            <!--class="mx-0"-->
            <!--&gt;提交-->
            <!--</v-btn>-->
            <!--<v-btn v-if="isEdit" color="grey" flat @click="goReadonly">取消</v-btn>-->
            <!--<v-btn v-if="!isEdit" color="primary" class="mx-0" flat @click="openPasswordDialog">修改密码</v-btn>-->
          </v-flex>
        </v-layout>
       <!-- <v-subheader>绑定分组</v-subheader>
        <v-layout wrap>
          <v-flex xs12>
            <l-data-table
              :headers="groupHeaders"
              :items="data.groupList"
              flat
              hide-actions
              hide-headers
              hide-title
              no-data-text="没有绑定分组"
            ></l-data-table>
          </v-flex>
        </v-layout>
        <v-subheader>绑定角色</v-subheader>
        <v-layout wrap>
          <v-flex xs12>
            <l-data-table
              :headers="roleHeaders"
              :items="data.roleList"
              flat
              hide-actions
              hide-headers
              hide-title
              no-data-text="没有绑定角色"
            ></l-data-table>
          </v-flex>
        </v-layout>-->
      </v-container>
    </v-card-text>
    <l-dialog
      width="400px"
      v-model="passwordDialog.activate"
      title="修改密码"
      :auto-close="false"
      :loading="passwordDialog.loading"
      @cancel="closePasswordDialog"
      @confirm="changePassword"
      :disable-confirm="!passwordValid"
    >
      <v-container grid-list-md class="pt-0">
        <v-form ref="password" v-model="passwordValid">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                id="old-pass"
                label="旧密码"
                :rules="$rules.required('初始密码不能为空')"
                type="password"
                browser-autocomplete="nope"
                prepend-icon="$vuetify.icons.lock"
                v-model="passwordDialog.form.oldPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="new-pass"
                label="新密码"
                type="password"
                browser-autocomplete="nope"
                :rules="[$rules.requiredS('新密码不能为空'),samePassword]"
                prepend-icon="$vuetify.icons.lockOutline"
                v-model="passwordDialog.form.newPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="重新输入"
                type="password"
                browser-autocomplete="nope"
                :rules="[$rules.requiredS('新密码不能为空'),v => v === passwordDialog.form.newPassword || '两次输入密码不一致']"
                prepend-icon="$vuetify.icons.lockReset"
                v-model="passwordDialog.form.repeatPassword"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </l-dialog>
    <l-dialog
      width="400px"
      v-model="emailDialog.activate"
      title="修改邮箱"
      :auto-close="false"
      :loading="emailDialog.loading"
      @cancel="closeEmailDialog"
      @confirm="changeEmail"
      :disable-confirm="!emailValid"
    >
      <v-container grid-list-md class="pt-0">
        <v-form ref="email" v-model="emailValid">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="新邮箱"
                :rules="emailRules"
                prepend-icon="$vuetify.icons.email"
                v-model="emailDialog.form.email"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </l-dialog>
    <l-dialog
      width="400px"
      v-model="phoneDialog.activate"
      title="修改手机"
      :auto-close="false"
      :loading="phoneDialog.loading"
      @cancel="closePhoneDialog"
      @confirm="changePhone"
      :disable-confirm="!phoneValid"
    >
      <v-container grid-list-md class="pt-0">
        <v-form ref="phone" v-model="phoneValid">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="新手机号码"
                :rules="phoneRules"
                prepend-icon="$vuetify.icons.phone"
                v-model="phoneDialog.form.phone"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </l-dialog>
  </v-card>
</template>

<script>
import {time} from '../../ladmin/utils'
import defaults from '../../consts'

export default {
  name: 'personalCard',
  props: {
    person: {type: Object, default: () => ({})},
  },
  data () {
    return {
      loading: false,
      emailRules: [
        this.$rules.requiredS('新邮箱不能为空'),
        v => /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/i.test(v) || '邮箱格式错误',
      ],
      phoneRules: [
        this.$rules.requiredS('新手机号码不能为空'),
        ...this.$rules.phone11(),
      ],
      emailValid: false,
      phoneValid: false,
      passwordValid: false,
      status: 'readonly',
      submitLoading: false,
      formValues: null,
      passwordDialog: {
        loading: false,
        activate: false,
        form: {
          oldPassword: '',
          newPassword: '',
          repeatPassword: '',
        },
      },
      emailDialog: {
        loading: false,
        activate: false,
        form: {
          email: '',
        },
      },
      phoneDialog: {
        loading: false,
        activate: false,
        form: {
          phone: '',
        },
      },
      groupHeaders: defaults.userAdmin.GROUP_HEADERS,
      roleHeaders: [
        {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
        {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
        {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
        {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      ],
    }
  },
  computed: {
    data () {
      if (this.status === 'readonly') {
        return this.person
      }
      else {
        return this.formValues
      }
    },
    isEdit () {
      return this.status === 'edit'
    },
    readonly () {
      return this.status === 'readonly'
    },
  },
  watch: {},
  methods: {
    async unBindWechatConfirm () {
      let {res, close} = await this.$L.confirm({
        title: '确认解除微信公众号绑定？',
      })
      if (res) {
        try {
          await this.unBindWechat()
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async unBindWechat () {
      this.loading = true
      try {
        let res = await this.$store.dispatch('wx/unBindWechat')
        if (res.data.status + '' === '1') {
          this.$L.alert('success', {message: '解除绑定成功'})
        }
        else {
          this.$L.alert('error', {message: '解除绑定失败，原因:' + res.data.msg})
        }
      }
      catch (e) {

      }
      finally {
        this.loading = false
      }
    },
    async getSelf () {
      try {
        await this.$store.dispatch('login/getSelfInfo')
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    samePassword (v) {
      return v !== this.passwordDialog.form.oldPassword || '不能和旧密码相同'
    },
    async changePassword () {
      let form = this.passwordDialog.form
      try {
        this.passwordDialog.loading = true
        await this.$store.dispatch('login/changePassword', {
          newPassword: form.newPassword,
          oldPassword: form.oldPassword,
        })
        this.$L.alert('success', '修改成功')
        this.closePasswordDialog()
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.passwordDialog.loading = false
      }
    },
    async changeEmail () {
      let form = this.emailDialog.form
      try {
        this.emailDialog.loading = true
        await this.$store.dispatch('login/changeEmail', {
          email: form.email,
        })
        this.$L.alert('success', '修改成功')
        this.getSelf()
        this.closeEmailDialog()
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.emailDialog.loading = false
      }
    },
    async changePhone () {
      let form = this.phoneDialog.form
      try {
        this.phoneDialog.loading = true
        await this.$store.dispatch('login/changePhone', {
          phone: form.phone,
        })
        this.$L.alert('success', '修改成功')
        this.closePhoneDialog()
        this.getSelf()
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.phoneDialog.loading = false
      }
    },
    openPasswordDialog () {
      this.passwordDialog = {
        activate: true,
        loading: false,
        form: {
          oldPassword: '',
          newPassword: '',
          repeatPassword: '',
        },
      }
      this.$refs.password.resetValidation()
    },
    closePasswordDialog () {
      this.passwordDialog = {
        loading: false,
        activate: false,
        form: {
          oldPassword: '',
          newPassword: '',
          repeatPassword: '',
        },
      }
    },
    openEmailDialog () {
      this.emailDialog = {
        activate: true,
        loading: false,
        form: {
          email: '',
        },
      }
      this.$refs.email.resetValidation()
    },
    closeEmailDialog () {
      this.emailDialog = {
        loading: false,
        activate: false,
        form: {
          email: '',
        },
      }
    },
    openPhoneDialog () {
      this.phoneDialog = {
        activate: true,
        loading: false,
        form: {
          phone: '',
        },
      }
      this.$refs.phone.resetValidation()
    },
    closePhoneDialog () {
      this.phoneDialog = {
        loading: false,
        activate: false,
        form: {
          phone: '',
        },
      }
    },
    async changeSelfInfo () {
      try {
        this.submitLoading = true
        await this.$store.dispatch('login/changeSelfInfo', this.formValues)
        this.$L.alert('success', '修改成功')
        this.goReadonly()
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    timeStringify (t) {
      return time.stringify(t)
    },
    goEdit () {
      this.formValues = Object.assign({}, this.person)
      this.status = 'edit'
    },
    goEditPhone () {
      this.openPhoneDialog()
    },
    goEditEmail () {
      this.openEmailDialog()
    },
    goReadonly () {
      this.status = 'readonly'
    },
  },
  create () {
  },
}
</script>

<style scoped>

</style>
